import React from "react";
import { AdminRoute } from "../../AdminRoute";
import KnowledgeBaseAnalytics from "../KnowledgeBaseAnalytics";

export const KnowledgeBaseAnalyticsRoute: React.FC = () => {
    return (
        <AdminRoute>
            <KnowledgeBaseAnalytics />
        </AdminRoute>
    );
};
